import {
  applyMiddleware, combineReducers, compose, createStore,
} from 'redux';
import thunk from 'redux-thunk';

import reducers from '#reducers';
import { getSentryReduxMiddleware, initializeSentry } from '../lib/sentry';
import newReducers from './reducers';


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

initializeSentry();
export default createStore(
  combineReducers({ ...reducers, ...newReducers }),
  composeEnhancers(applyMiddleware(thunk, getSentryReduxMiddleware())),
);
